import WhiteContainer from './WhiteContainer/WhiteContainer';

export default WhiteContainer;
